// import JSBridgeProtocol from '@ke/jsbridge-x/lib/typings/JSBridgeProtocol'
import request from "./request";

export class JSBridgeBrowser {
	
	// constructor () {
	// 	super();
	// }
	
	closeWebView() {
		return window.history.back()
	}
	
	// way表示新起还是覆盖，先支持新起
	openWebView(url, way) {
		return window.location.href(url)
	}
	
	actionShare(shareConfig) {
		return () => {}
	}
	
	async getUserInfo() {
		const res = await request('getUserId')
			.then(data => {
				return data.user_id
			})
			.catch(e => {
				return e.message
			})
		const userInfo = {
			userId: res
		}
		
		return [userInfo,]
	}
	
	async login() {
		const res = await request('getUserId')
			.then(data => {
				return data.user_id
			})
			.catch(e => {
				return e.message
			})
		
		return res
	}
	
	async logout() {
		return {}
	}
	
	async closeLoading() {
		return {}
	}
	
	async getBangsHeight() {
		return 0
	}
}
